import React from 'react';
import { useToast } from '../context/ToastContext';

const STYLES = {
  error: 'bg-error-bg text-error-tx border-error-tx/20',
  success: 'bg-success-bg text-success-tx border-success-tx/20',
  info: 'bg-info-bg text-info-tx border-info-tx/20',
};

export default function ToastContainer() {
  const { toasts, dismiss } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed top-4 right-4 z-50 flex flex-col gap-2 w-[calc(100%-2rem)] max-w-sm">
      {toasts.map((t) => (
        <div
          key={t.id}
          role="alert"
          className={`flex items-start gap-3 border rounded-xl px-4 py-3 shadow-md ${STYLES[t.type] || STYLES.info}`}
        >
          <span className="flex-1 text-sm font-medium">{t.message}</span>
          <button
            onClick={() => dismiss(t.id)}
            aria-label="Dismiss"
            className="text-current opacity-60 hover:opacity-100 transition-opacity leading-none"
          >
            &times;
          </button>
        </div>
      ))}
    </div>
  );
}
